import { useEffect, useState, useRef } from "react";
import { useSearchParams, Link } from "react-router-dom";
import api, { formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { CheckCircle2, AlertCircle, ArrowLeft } from "lucide-react";

export default function VerifyEmailPage() {
    const [params] = useSearchParams();
    const token = params.get("token");
    const { refreshUser } = useAuth();
    const [status, setStatus] = useState({ loading: true, ok: false, msg: "" });
    const ran = useRef(false);

    useEffect(() => {
        if (ran.current) return;
        ran.current = true;
        if (!token) {
            setStatus({ loading: false, ok: false, msg: "This confirmation link is missing its token." });
            return;
        }
        api.get("/auth/verify-email", { params: { token } })
            .then((r) => {
                setStatus({ loading: false, ok: true, msg: r.data.message });
                refreshUser();
            })
            .catch((err) => setStatus({ loading: false, ok: false, msg: formatApiError(err.response?.data?.detail) }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);

    return (
        <div className="max-w-md mx-auto px-4 py-24 text-center" data-testid="verify-email-page">
            {status.loading ? (
                <p className="inline-flex items-center gap-2 font-mono text-sm text-dim">
                    <span className="w-1.5 h-1.5 rounded-full bg-accent animate-pulse-dot" />
                    Confirming your email…
                </p>
            ) : status.ok ? (
                <div className="panel p-10 border-pos/30" data-testid="verify-success">
                    <span className="grid place-items-center w-16 h-16 mx-auto rounded-full bg-pos/10 text-pos">
                        <CheckCircle2 size={30} />
                    </span>
                    <h1 className="font-display text-2xl font-black uppercase tracking-[-0.025em] mt-5">Email confirmed</h1>
                    <p className="mt-3 text-sm text-dim leading-relaxed">{status.msg}</p>
                </div>
            ) : (
                <div className="panel p-10 border-neg/30" data-testid="verify-error">
                    <span className="grid place-items-center w-16 h-16 mx-auto rounded-full bg-neg/10 text-neg">
                        <AlertCircle size={30} />
                    </span>
                    <h1 className="font-display text-2xl font-black uppercase tracking-[-0.025em] mt-5">Confirmation failed</h1>
                    <p className="mt-3 text-sm text-dim leading-relaxed">{status.msg}</p>
                </div>
            )}
            <Link to="/" className="mt-8 inline-flex items-center gap-1.5 font-mono text-xs uppercase tracking-wider text-accent link-underline">
                <ArrowLeft size={13} /> Back home
            </Link>
        </div>
    );
}
